import React, {useEffect, useState} from "react";
import {
    CreateTacticTextField,
    qtyFieldAdornment
} from "../../../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/CreateTradePlanTree";
import UpDownArrayIncrementDecrement from "../../../../../utils/componentutils/UpDownArrayIncrementDecrement";
import InputLabel from "@material-ui/core/InputLabel";
import {Input, TextField, Typography} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import RadioGroup from "@material-ui/core/RadioGroup";

export default function QuantityBasisValueTxtBox({
                                                     top, dispatchTop,
                                                     qtyBasis,
                                                     entryTactics,
                                                     dispatchMarketOrder,
                                                     dispatchLimitOrder,
                                                     dispatchCandleBreak,
                                                     qtyBasisValue,
                                                     setQtyBasisValue
                                                 }) {
    let adornment = qtyFieldAdornment(top);

    const handleChange = (ev) => {
        let value = ev.target.value;
        if (entryTactics["MARKET_ORDER"] !== undefined) {
            dispatchMarketOrder({
                quantityBasisValue: parseFloat(value),
            });
        } else if (entryTactics["LIMIT_ORDER"] !== undefined) {
            dispatchLimitOrder({
                quantityBasisValue: parseFloat(value),
            });
        } else if (entryTactics["CANDLE_BREAK"] !== undefined) {
            dispatchCandleBreak({
                quantityBasisValue: parseFloat(value),
            });
        }
    };

    let keyActionQtyBasis = (ev) =>
        UpDownArrayIncrementDecrement(
            ev.key,
            1,
            parseInt(qtyBasisValue),
            (quantityBasisValue) => handleChange(quantityBasisValue),
            0
        );

    let inputProps = {
        endAdornment: adornment,
        onKeyDown: keyActionQtyBasis,
    };


    return (
        /*<div className="m-2">*/
        <Grid container>
            <Grid item xs={6}>
                <RadioGroup
                    row
                    aria-label="qtyBasis"
                    name="qtyBasis"
                    onChange={(ev) => {
                        dispatchTop({quantityBasis: ev.target.value});
                    }}
                >
                    <Grid item xs={4}>
                        <FormControlLabel
                            value="QUANTITY"
                            checked={qtyBasis === "QUANTITY"}
                            control={<StyledRadio/>}
                            label={
                                <Typography style={{fontSize: 10}}>Qty</Typography>
                            }
                            labelPlacement={"top"}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormControlLabel
                            value="DOLLARS"
                            checked={qtyBasis === "DOLLARS"}
                            control={<StyledRadio/>}
                            label={
                                <Typography style={{fontSize: 10}}>$</Typography>
                            }
                            labelPlacement={"top"}
                        />
                    </Grid>
                </RadioGroup>
            </Grid>
            <Grid item xs={6}>
                <TextField
                    margin={"none"}
                    size={"small"}
                    label={<Typography
                        style={{fontSize: 10}}> {qtyBasis === undefined ? "quantity basis value" : qtyBasis} < /Typography>}
                    //variant="outlined"
                    value={qtyBasisValue}
                    onChange={ev => {
                        setQtyBasisValue(ev.target.value);
                    }}
                    onBlur={handleChange}
                    //required
                />
            </Grid>
        </Grid>
        /*</div>*/
        /*<TextField>
            label={<Typography>{qtyBasis === undefined ? "quantity basis value" : qtyBasis} </Typography>}
            value={qtyBasisValue}
            size={"small"}
            style={{height: 12, fontSize: 8, width: "100%"}}
            onChange={ev => setQtyBasisValue(ev.target.value)}
            onBlur={handleChange}
            {/!*<Input
                //id={label}
                //size="small"
                //style={{height: 15, fontSize: 12, width: 60}}
                //value={reference.current}
                onChange={async (ev) => {
                    setField(ev.target.value);
                }}
                onBlur={(ev) => onBlurFunc(ev)}
                {...props}
            />*!/}
        </TextField>*/
        /*<CreateTacticTextField
            label={qtyBasis === undefined ? "quantity basis value" : qtyBasis}
            defaultValue={qtyBasisValue}
            onBlurFunc={(ev) => handleChange(ev.target.value)}
            props={inputProps}
        />*/
    )

}